import axios from 'axios';
import { jwtService } from './jwt'

const { API_URL } = require('../config.json')

axios.defaults.timeout = 400000;
axios.defaults.withCredentials = true;
axios.defaults.baseURL = API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use(response => {
	return response;
}, error => {
	if (!error.response) {
		// Handle API Offline Error
	}
	else if (error.response.status === 401) {
		//
	}
	return error;
})

axios.refreshToken = () => {
	axios.defaults.headers.common['Authorization'] = localStorage.getItem('token') ? 'Bearer ' + localStorage.getItem('token') : (localStorage.getItem('tempToken') ? 'Bearer ' + localStorage.getItem('tempToken') : '')
}

axios.generateTempToken = async () => {
	const now = parseInt(new Date().getTime() / 1000);

	const tempToken = localStorage.getItem('tempToken')

	let tempTokenData

	if (tempToken)
		tempTokenData = jwtService.decode(tempToken)

	if (!tempToken || now > tempTokenData.payload.exp) {
		const response = await axios.get('/user/temptoken')

		if (!response)
			return false;

		localStorage.setItem('tempToken', response.data.token);
	}

	axios.refreshToken()
}

axios.refreshToken()

export default axios